<template>
  <div
    class="kai-answers-bottom-bar"
    :class="{live_chat_open_up:this.$parent.isLiveChatStarted && !this.$parent.useWidgetMode, live_chat_open_down:this.$parent.isLiveChatStarted && this.$parent.useWidgetMode, bottomBarWidget: this.$parent.useWidgetMode}"
  >
    <ChipPanelQbar
      v-if="this.$parent.chipItemLength > 0"
      :response="this.$parent.response"
    />
    <button
      class="fresh-start-btn"
      :class="{
        'fresh-start-btn-widget':this.$parent.useWidgetMode,
        'fresh-start-btn-not-widget': !this.$parent.useWidgetMode && !this.$parent.displaySource,
        'display-source-fresh-start-btn': !this.$parent.useWidgetMode && this.$parent.displaySource,
      }"
      @click="this.$parent.freshStartClick"
    >
      Fresh Start
    </button>
    <transition name="recording-fade">
      <div
        class="kai-textarea"
        :class="{'kai-textarea-widget':this.$parent.useWidgetMode}"
      >
        <input
          id="kai-input-prompt-area"
          ref="kaiInputPromptArea"
          v-model="$parent.userRequest.message"
          class="kai-input-prompt"
          tabindex="0"
          autocomplete="off"
          :dir="$store.state.enableRTL ? 'rtl' : 'auto'"
          :placeholder="this.$parent.inputPlaceHolder"
          :aria-label="this.$parent.inputPlaceHolder"
          @keyup="$parent.inputMessageChange"
          @keydown.enter="kaiAnswersSendMessage"
          @keydown="handlePasteShortcuts"
        >

        <div
          v-if="showStopGenerating"
          class="kai-stop-generating"
        >
          <img
            :src="stopIcon"
            alt=""
            @mouseenter="showHoverStopIcon()"
            @mouseleave="showDefaultStopIcon()"
            @click="stopGenerating()"
          >
        </div>
      </div>
    </transition>
    <button
      class="kai-send-button"
      :aria-label="this.$parent.translations.sendMessageButton"
      tabindex="0"
      :class="{'kai-send-button-disabled': isSendDisabled}"
      @click="kaiAnswersSendMessage"
    >
      <svg width="25" height="22" viewBox="0 0 31 22" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M0.218994 0.181641V8.88871L6.04453 10.9998L0.218994 13.1109V21.818L30.0702 10.9998L0.218994 0.181641Z" class="kai-send-arrow-top" />
        <path fill-rule="evenodd" clip-rule="evenodd" d="M0.218994 0.181641V9.40089L5.8161 10.9998H30.0702L0.218994 0.181641Z" class="kai-send-arrow-bottom" />
      </svg>
    </button>
  </div>
</template>

<script>

import ImageUtilityMixin from './Mixin/ImageUtilityMixin'
import TextMixin from './Mixin/TextMixin'

export default {
  name: 'KaiAnswersBottomBar',
  mixins: [ImageUtilityMixin, TextMixin],
  data () {
    return {
      stopIcon: '',
      sendIcon: '',
    }
  },
  computed: {
    kaiAnswersStopIcon () {
      return this.getImagePath('svg/kai_answers_stop_icon.svg')
    },
    kaiAnswersStopIconHover () {
      return this.getImagePath('svg/kai_answers_stop_icon_hover.svg')
    },
    showStopGenerating () {
      return $store.state.showStopGenerating
    },
    isSendDisabled () {
      return $store.state.sendMessageDisabled
    },
    kaiAnswersSendIcon () {
      return this.getImagePath('svg/kai_answers_send_icon.svg')
    },
    kaiAnswersSendIconDisabled () {
      return this.getImagePath('svg/kai_answers_send_disabled_icon.svg')
    }
  },
  watch: {
    isSendDisabled (val) {
      if (val) {
        this.sendIcon = this.kaiAnswersSendIconDisabled
      } else {
        this.sendIcon = this.kaiAnswersSendIcon
      }
    }
  },
  mounted () {
    this.showDefaultStopIcon()
    this.sendIcon = this.kaiAnswersSendIcon
  },
  methods: {
    showDefaultStopIcon () {
      this.stopIcon = this.kaiAnswersStopIcon
    },
    showHoverStopIcon () {
      this.stopIcon = this.kaiAnswersStopIconHover
    },
    stopGenerating () {
      console.log('stop generating')
      $store.state.showStopGenerating = false
    },
    kaiAnswersSendMessage (event) {
      if ($store.state.sendMessageDisabled) {
        console.log('send message disabled')
        return
      }
      $store.state.sendMessageDisabled = true
      this.$parent.sendMessage(event)
    }
  }
}

</script>

<style lang="less" src='./styles/KaiAnswersBottomBar.less' scoped>
</style>

<style scoped>
  .kai-chat-message {
    max-width: 70% !important;
  }
</style>
